import React, {
  Component,
  MouseEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useStore } from "../store";
import Card from "react-bootstrap/Card";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { Colors } from "../utils/style";

type Prop = {
  title: string;
  icon?: IconProp;
  children?: ReactNode;
  width?: string;
  titleHeight?: string;
};
function AddDataSourceCardComponent(props: Prop) {
  const [isHovered, setIsHovered] = useState(false);

  const handleHover = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: props.width ? props.width : "100%",
        }}
      >
        <Card
          className="p-3 text-center "
          style={{
            cursor: "pointer",
            width: props.width ? props.width : "100%",
            height: props.titleHeight ? props.titleHeight : "",
            minWidth: "10rem",
            backgroundColor: "#e5e4e2",
            borderColor: isHovered ? "green" : "",
          }}
          onMouseOver={handleHover}
          onMouseLeave={handleMouseLeave}
        >
          {/* Icon */}
          <FontAwesomeIcon
            icon={props.icon || faUpload}
            size="2x"
            color={Colors.DARK_BLUE}
            className="mb-3"
          />

          <div style={{ fontSize: "20px", color: Colors.DARK_BLUE }}>
            {props.title}
          </div>

          <FontAwesomeIcon
            icon={faPlus}
            size="2x"
            color={Colors.DARK_BLUE}
            className="mb-3"
          />
        </Card>
      </div>
    </>
  );
}

export default AddDataSourceCardComponent;
